// ConfirmReserveModal.js

import React from 'react';
import './ConfirmReserveModal.css';

const ConfirmReserveModal = ({ isOpen, onConfirm, onCancel, cartItems }) => {
  if (!isOpen) return null;

  const totalPrice = cartItems.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Confirmar Reserva</h2>
        <p>¿Estás seguro de que deseas reservar los siguientes productos?</p>
        <ul>
          {cartItems.map(item => (
            <li key={item._id}>
              <strong>{item.name}</strong> x {item.quantity}
            </li>
          ))}
        </ul>
        <p><strong>Total:</strong> {totalPrice.toFixed(2)} €</p>
        <div className="modal-buttons">
          <button onClick={onConfirm} className="confirm-button">Sí, Reservar</button>
          <button onClick={onCancel} className="cancel-button">Cancelar</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmReserveModal;
